export default __webpack_public_path__ + "static/media/maxresdefault.af2ab966.jpg";